export default __webpack_public_path__ + "static/media/chef.fb9357b4.svg";